import React,{useEffect} from 'react'
import Router from '@/routes'
import "./index.scss"
import VConsole from "vconsole"
import 'animate.css';
function App() {
  useEffect(()=>{
    if(window?.location.host.includes('test')){
      window.VConsole = new VConsole({ maxLogNumber: 1000 });
      // Position the VConsole panel on the lower left middle
      setTimeout(() => {
        const vcSwitch = document.querySelector('.vc-switch');
        if (vcSwitch) {
          vcSwitch.style.left = '10px';
          vcSwitch.style.bottom = '25%';
          vcSwitch.style.right = 'auto';
        }
      }, 100);
    }
  },[])
  return (
    <div style={{ width:"100%",height:"100%"}}>
      <Router/>
    </div>
  )
}
export default App